import { makeAuthenticatedRequest } from './authService';

// ========================================
// Types for MCQ Service
// ========================================

export interface MCQQuestion {
  question: string;
  options: string[]; // 4 options
  correctAnswer: number; // 0-3 index
}

export interface MCQQuestionsResponse {
  questions: MCQQuestion[];
  lesson_id: string;
  lesson_name: string;
  category_id: string;
  category_name: string;
}

export interface GenerateMCQRequest {
  category_id?: string;
  lesson_id?: string;
  num_questions?: number; // Optional, default 5
}

// ========================================
// MCQ Service Class
// ========================================

export class MCQService {
  /**
   * Generate MCQ questions from a knowledge category lesson
   */
  static async generateQuestions(data: GenerateMCQRequest): Promise<MCQQuestionsResponse> {
    try {
      const requestBody: any = {
        num_questions: data.num_questions || 5
      };
      
      if (data.category_id) {
        requestBody.category_id = data.category_id;
      }
      
      if (data.lesson_id) {
        requestBody.lesson_id = data.lesson_id;
      }

      const response = await makeAuthenticatedRequest('/mcq-questions/generate', {
        method: 'POST',
        body: JSON.stringify(requestBody)
      });

      if (!response.success) {
        throw new Error(response.message || 'Failed to generate MCQ questions');
      }

      return response.data;
    } catch (error) {
      console.error('Error generating MCQ questions:', error);
      throw error;
    }
  }
}

export default MCQService;

